<script>
import {Line, mixins} from 'vue-chartjs'
//todo refactor chartjs
// import {Line} from 'vue-chartjs/src/BaseCharts'
// import mixins from 'vue-chartjs/src/mixins'
import {mapGetters} from "vuex";

const {reactiveProp} = mixins;
export default {
  extends: Line,
  mixins: [reactiveProp],
  computed: {
    ...mapGetters('space', ['spaceCurrency']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
  },
  mounted() {
    this.renderChart(this.chartData, {
      onClick: (event) => {
        if (!!this.$data._chart.getElementAtEvent(event)[0]) {
          const index = this.$data._chart.getElementAtEvent(event)[0]._index
          this.$emit('click', index)
        } else {
          this.$emit('click', null)
        }
      },
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          ticks: {
            callback: (value) => {
              return this.displayCurrencyValue(value, this.spaceCurrency, true, true);
            },
            suggestedMax: 100,
          },
          stacked: true,
        }],
        xAxes: [{
          stacked: true
        }]
      },
      hover: {
        mode: 'nearest',
        intersect: true,
        onHover: (e) => {
          let elem = this.$data._chart.getElementAtEvent(e)[0]
          this.$data._chart.canvas.style.cursor = elem ? "pointer" : "default"
        },
      },
      tooltips: {
        mode: 'nearest',
        intersect: false,
        // callbacks: {
        //     label: (tooltipItem, data) => {
        //         if (data.datasets.length === 1) {
        //             const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        //             return `${this.spaceMoneyFormat(value) || 0}`;
        //         } else {
        //             const label = data.datasets[tooltipItem.datasetIndex].label;
        //             const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        //             let total = 0;
        //             for (let i = 0; i < data.datasets.length; i++)
        //                 total += data.datasets[i].data[tooltipItem.index];
        //             //todo when api ready replace string label w label
        //             if (tooltipItem.datasetIndex !== data.datasets.length - 1) {
        //                 return label + ": " + `${this.spaceMoneyFormat(value) || 0}`;
        //             } else {
        //                 return [label + ": " + `${this.spaceMoneyFormat(value) || 0}`,]
        //                 // "Total : " + `${this.spaceMoneyFormat(total) || 0}`];
        //             }
        //         }
        //     }
        // },
        enabled: false,
        custom: (tooltipModel) => {
          // Tooltip Element
          const chart_tooltip_id = 'chartjs-tooltip-' + this.$data._chart.canvas.id;
          let tooltipEl = document.getElementById(chart_tooltip_id);
          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = chart_tooltip_id;
            tooltipEl.classList.add('chartjs-tooltip');
            tooltipEl.innerHTML = "<table></table>"
            this.$data._chart.canvas.parentElement.appendChild(tooltipEl);
          }

          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform');
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
          } else {
            tooltipEl.classList.add('no-transform');
          }

          function getBody(bodyItem) {
            return bodyItem.lines;
          }

          // Set Text
          if (tooltipModel.body) {
            let titleLines = tooltipModel.title || [];
            let bodyLines = tooltipModel.body.map(getBody);

            let innerHtml = '<thead>';

            titleLines.forEach(function (title) {
              innerHtml += '<tr><th>' + title + '</th></tr>';
            });
            innerHtml += '</thead><tbody>';

            bodyLines.forEach((body, i) => {
              let colors = tooltipModel.labelColors[i],
                  style = 'background:' + colors.backgroundColor;
              style += '; border-color:' + colors.borderColor;
              style += '; border-width: 1px';
              let span = '<span class="chartjs-tooltip-key" style="' + style + '"></span>',
                  label = body[0].split(':')[0],
                  value = body[0].split(':')[1];
              innerHtml += `<tr><td>${span}${label}: ${this.displayCurrencyValue(+value, this.spaceCurrency)}</td></tr>`;
            });
            innerHtml += '</tbody>';

            let tableRoot = tooltipEl.querySelector('table');
            tableRoot.innerHTML = innerHtml;
          }

          let positionY = this.$data._chart.canvas.offsetTop;
          let positionX = this.$data._chart.canvas.offsetLeft;

          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = positionX + tooltipModel.caretX + 'px';
          tooltipEl.style.top = positionY + tooltipModel.caretY - tooltipModel.height * 1.5 + 'px';
          tooltipEl.style.fontSize = '12px';
          tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        }
      },
      responsive: true,
      maintainAspectRatio: false
    })
  }
}
</script>